import React from 'react'
// import resume from '../../assets/image/resume.avif'
// import resume2 from '../../assets/image/resume2.avif'
import resume3 from '../../assets/image/resume3.avif'
// import download from '../../assets/image/Darshik_Rajpara.pdf'
import resume from "../../assets/Darshik'sCV.pdf"

export const Resume = () => {
    return (
        <>
            <div id='resume' className='px-5 md:px-20 xl:px-32 text-center text-surface lg:text-left py-14 md:py-5 relative flex justify-center dark:text-tx-col min-h-[86vh]'>
                <div className="">
                    <img className='h-fit' src={resume3} alt="Resume of Darshik Rajpara" />
                    {/* <a className='absolute bottom-10 md:bottom-5 right-5 backdrop-blur-xl bg-white/5 px-4 py-2 rounded-md text-xs md:text-sm xl:text-base' href={resume3} download="Darshik'sCV">Download</a> */}
                    <a className='absolute bottom-10 md:bottom-5 right-5 backdrop-blur-xl bg-white/5 px-4 py-2 rounded-md text-xs md:text-sm xl:text-base' href={resume} target='_blank' rel="noreferrer">Download</a>
                </div>
            </div>
        </>
    )
}
